export default {
    name: 'InfoFilled',
    dimensions: { width: 22, height: 23 },
    content: `
      <path
        fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 0.75C4.92487 0.75 0 5.67487 0 11.75C0 17.8251 4.92487 22.75 11 22.75C17.0751 22.75 22 17.8251 22 11.75C22 5.67487 17.0751 0.75 11 0.75ZM10.5 8.75C11.3284 8.75 12 8.07843 12 7.25C12 6.42157 11.3284 5.75 10.5 5.75C9.67157 5.75 9 6.42157 9 7.25C9 8.07843 9.67157 8.75 10.5 8.75ZM8 11C8 10.4477 8.44771 10 9 10H11C11.5523 10 12 10.4477 12 11V15H13C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17H11H9C8.44771 17 8 16.5523 8 16C8 15.4477 8.44771 15 9 15H10V12H9C8.44771 12 8 11.5523 8 11Z"
      />
    `
};
